
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ukiOFLyGNe6yXuueGs77rUVFS7AYwiiQxiiOl3Q3QJNM0Meta } from "/vercel/path0/pages/uk.vue?macro=true";
import { default as usvOXPQTY5RaNZp67l39ogitCJSZhL_458SCP10MwfEyvDQMeta } from "/vercel/path0/pages/us.vue?macro=true";
import { default as togoS5G2evl7FM96U5IvL2OMelr6rbhA2VrlPLsnTzhWtxMMeta } from "/vercel/path0/pages/togo.vue?macro=true";
import { default as aboutOS7HpsGFDFSTbbd4iXDP92Iuvckam0GQw5dgZEXCgBIMeta } from "/vercel/path0/pages/about.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as indiaKp73hQ7G5NUYPAQYGWSFyjIIzKvpbQ9qrs_45KHoJaPyoMeta } from "/vercel/path0/pages/india.vue?macro=true";
import { default as koreaq_s1s51o6_45PQaosL5jAZh8uugSa8sEjoCotzUsJ1cEkMeta } from "/vercel/path0/pages/korea.vue?macro=true";
import { default as termsrbl0AisEJEK94jgNDoimMHDtED_45cqOs4QSX5phnU96AMeta } from "/vercel/path0/pages/terms.vue?macro=true";
import { default as canadam0VVFkQewuyQeZaENgbmbevkVUj7GiraFOM6w5cgf2oMeta } from "/vercel/path0/pages/canada.vue?macro=true";
import { default as israelSQLf0g2MFAlnKI2100NjLtrCvl94027wGapvC6xz8f8Meta } from "/vercel/path0/pages/israel.vue?macro=true";
import { default as status0fkb9rq55MfHDoKUam0me9DqAL7ScJ6MRNHTBXwYRvgMeta } from "/vercel/path0/pages/status.vue?macro=true";
import { default as bahrain9T_45ThEsiojYPRYQx85murtHfjm5iLHzUkUmUzj49bAgMeta } from "/vercel/path0/pages/bahrain.vue?macro=true";
import { default as contact6cZoOGxJBTY9l_45DSf37OWQKprIBU1PffJx7PVn14dCsMeta } from "/vercel/path0/pages/contact.vue?macro=true";
import { default as failureAn8cY_PuTrA3LT6TNZ5jSl1xvxeMTa7UYy22CcnTlqsMeta } from "/vercel/path0/pages/failure.vue?macro=true";
import { default as moroccoMODXJWrKqMy1C9rXtTLAx_45L6XNVMu9WsJvXKqPzmNPgMeta } from "/vercel/path0/pages/morocco.vue?macro=true";
import { default as privacyoUxJze_459YVMN19fHCMNcOPA4bNg1TjmwARd6j9aojjEMeta } from "/vercel/path0/pages/privacy.vue?macro=true";
import { default as successNhuXZrifDFrJuYmZhJLbJXAfeRoouILUxT6r8EhW6BwMeta } from "/vercel/path0/pages/success.vue?macro=true";
import { default as vietnamQnPs83gzl7bAn28LTGXIwT8ImJehYwewX3j_45K65hS0UMeta } from "/vercel/path0/pages/vietnam.vue?macro=true";
import { default as cambodiagskf8H6JFqvs0EdYmL6ZM8IpUR1fq_gaV7AJEiKqTCAMeta } from "/vercel/path0/pages/cambodia.vue?macro=true";
import { default as thailandJz4HGoIFFiIZOOGMy1j8Wlb4XTWuURaIOheCrD_fh5UMeta } from "/vercel/path0/pages/thailand.vue?macro=true";
import { default as indonesiaHoI1y3sRhldySjbhQyFP5T1J4_UbCVGvHJbuFkVv0CoMeta } from "/vercel/path0/pages/indonesia.vue?macro=true";
import { default as sri_45lanka4PHR78gTv4iVfrgirR6S7UzFfUNGdacqC_451htqmPHiYMeta } from "/vercel/path0/pages/sri-lanka.vue?macro=true";
import { default as sendXRUsm5FPMBlbetoU4jpz6UcuYRObD_GMOkVhxpW4CewMeta } from "/vercel/path0/pages/admin/send.vue?macro=true";
import { default as indexDIlA_VwVYEsF82JYYTptIRBexsOVSbsbgl1xBQ_lIIoMeta } from "/vercel/path0/pages/blog/index.vue?macro=true";
import { default as formsW5j14Pg3zlZVItRrcHHxgUgLUu_u9rhCwtnmE5MZ2k8Meta } from "/vercel/path0/pages/admin/forms.vue?macro=true";
import { default as index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta } from "/vercel/path0/pages/admin/index.vue?macro=true";
import { default as loginIttlbhtfUQOaWpAXQFNnY8SXo7S4sj5LEwH2cphGptIMeta } from "/vercel/path0/pages/admin/login.vue?macro=true";
import { default as _91slug_93v3ez11IMRk2feKAiBpS9mVspk4W7_E8tt32O22_45Wq2cMeta } from "/vercel/path0/pages/blog/[slug].vue?macro=true";
import { default as new_45zealandAVS41WburjtfXX4Hf1XJ5sLBtQguncYLLeiC570Wuj4Meta } from "/vercel/path0/pages/new-zealand.vue?macro=true";
import { default as saudi_45arabiagIcXS71ij0zkWGLnb7L1bShtmoKxufelCXYJijuk6iwMeta } from "/vercel/path0/pages/saudi-arabia.vue?macro=true";
import { default as couponsWllS_45Vyq2nDWNW1lhmnP_45cdeEOpBVINdB61cFqutevoMeta } from "/vercel/path0/pages/admin/coupons.vue?macro=true";
import { default as products7xWmb8q8YY3CywbixOugJdgnwuNy1wX7rt2Mdv6u44sMeta } from "/vercel/path0/pages/admin/products.vue?macro=true";
import { default as indexjLO3koDp4NEyNO9S6YF_ojLGBgHUZkdDQoxKEc5ww7UMeta } from "/vercel/path0/pages/admin/emails/index.vue?macro=true";
import { default as email_45previewqaxMI3o4PPpsafZqfwt_45iiuqBZZGCdbg1N5Cr0QaGvoMeta } from "/vercel/path0/pages/admin/email-preview.vue?macro=true";
import { default as _91order_93hx4ZATvYsJbncEWkI_ngYONXXRCh1i2qBNkwQCweEVIMeta } from "/vercel/path0/pages/admin/order/[order].vue?macro=true";
import { default as _91email_93p8OXWoODgw8TdZj_45_452zoO9xakhAUyeaScwT_45IW5q3OQMeta } from "/vercel/path0/pages/admin/emails/[email].vue?macro=true";
import { default as _91author_93e3CyVbDY_45A2eSp1b7DqYDFb7BsdPcho_bDj_45U_45ePxSUMeta } from "/vercel/path0/pages/blog/author/[author].vue?macro=true";
import { default as _91category_93z_yALMEg3eBL9sYIfchp_45WItcyZ2mZe32dYBIU9l6sAMeta } from "/vercel/path0/pages/blog/category/[category].vue?macro=true";
import { default as component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyUMeta } from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.2_eslint@9_5mlcxkqws6cnbyrsus4vvb2kg4/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyU } from "/vercel/path0/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.2_eslint@9_5mlcxkqws6cnbyrsus4vvb2kg4/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "uk",
    path: "/uk",
    component: () => import("/vercel/path0/pages/uk.vue")
  },
  {
    name: "us",
    path: "/us",
    component: () => import("/vercel/path0/pages/us.vue")
  },
  {
    name: "togo",
    path: "/togo",
    component: () => import("/vercel/path0/pages/togo.vue")
  },
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path0/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "india",
    path: "/india",
    component: () => import("/vercel/path0/pages/india.vue")
  },
  {
    name: "korea",
    path: "/korea",
    component: () => import("/vercel/path0/pages/korea.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/vercel/path0/pages/terms.vue")
  },
  {
    name: "canada",
    path: "/canada",
    component: () => import("/vercel/path0/pages/canada.vue")
  },
  {
    name: "israel",
    path: "/israel",
    component: () => import("/vercel/path0/pages/israel.vue")
  },
  {
    name: "status",
    path: "/status",
    component: () => import("/vercel/path0/pages/status.vue")
  },
  {
    name: "bahrain",
    path: "/bahrain",
    component: () => import("/vercel/path0/pages/bahrain.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/vercel/path0/pages/contact.vue")
  },
  {
    name: "failure",
    path: "/failure",
    component: () => import("/vercel/path0/pages/failure.vue")
  },
  {
    name: "morocco",
    path: "/morocco",
    component: () => import("/vercel/path0/pages/morocco.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/vercel/path0/pages/privacy.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/vercel/path0/pages/success.vue")
  },
  {
    name: "vietnam",
    path: "/vietnam",
    component: () => import("/vercel/path0/pages/vietnam.vue")
  },
  {
    name: "cambodia",
    path: "/cambodia",
    component: () => import("/vercel/path0/pages/cambodia.vue")
  },
  {
    name: "thailand",
    path: "/thailand",
    component: () => import("/vercel/path0/pages/thailand.vue")
  },
  {
    name: "indonesia",
    path: "/indonesia",
    component: () => import("/vercel/path0/pages/indonesia.vue")
  },
  {
    name: "sri-lanka",
    path: "/sri-lanka",
    component: () => import("/vercel/path0/pages/sri-lanka.vue")
  },
  {
    name: "admin-send",
    path: "/admin/send",
    meta: sendXRUsm5FPMBlbetoU4jpz6UcuYRObD_GMOkVhxpW4CewMeta || {},
    component: () => import("/vercel/path0/pages/admin/send.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/vercel/path0/pages/blog/index.vue")
  },
  {
    name: "admin-forms",
    path: "/admin/forms",
    meta: formsW5j14Pg3zlZVItRrcHHxgUgLUu_u9rhCwtnmE5MZ2k8Meta || {},
    component: () => import("/vercel/path0/pages/admin/forms.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: index7u0xZi1WFYzsQuSx2TiTvZdGQqykCNS5mFv5C_1XsagMeta || {},
    component: () => import("/vercel/path0/pages/admin/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    component: () => import("/vercel/path0/pages/admin/login.vue")
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/vercel/path0/pages/blog/[slug].vue")
  },
  {
    name: "new-zealand",
    path: "/new-zealand",
    component: () => import("/vercel/path0/pages/new-zealand.vue")
  },
  {
    name: "saudi-arabia",
    path: "/saudi-arabia",
    component: () => import("/vercel/path0/pages/saudi-arabia.vue")
  },
  {
    name: "admin-coupons",
    path: "/admin/coupons",
    meta: couponsWllS_45Vyq2nDWNW1lhmnP_45cdeEOpBVINdB61cFqutevoMeta || {},
    component: () => import("/vercel/path0/pages/admin/coupons.vue")
  },
  {
    name: "admin-products",
    path: "/admin/products",
    component: () => import("/vercel/path0/pages/admin/products.vue")
  },
  {
    name: "admin-emails",
    path: "/admin/emails",
    meta: indexjLO3koDp4NEyNO9S6YF_ojLGBgHUZkdDQoxKEc5ww7UMeta || {},
    component: () => import("/vercel/path0/pages/admin/emails/index.vue")
  },
  {
    name: "admin-email-preview",
    path: "/admin/email-preview",
    meta: email_45previewqaxMI3o4PPpsafZqfwt_45iiuqBZZGCdbg1N5Cr0QaGvoMeta || {},
    component: () => import("/vercel/path0/pages/admin/email-preview.vue")
  },
  {
    name: "admin-order-order",
    path: "/admin/order/:order()",
    meta: _91order_93hx4ZATvYsJbncEWkI_ngYONXXRCh1i2qBNkwQCweEVIMeta || {},
    component: () => import("/vercel/path0/pages/admin/order/[order].vue")
  },
  {
    name: "admin-emails-email",
    path: "/admin/emails/:email()",
    meta: _91email_93p8OXWoODgw8TdZj_45_452zoO9xakhAUyeaScwT_45IW5q3OQMeta || {},
    component: () => import("/vercel/path0/pages/admin/emails/[email].vue")
  },
  {
    name: "blog-author-author",
    path: "/blog/author/:author()",
    component: () => import("/vercel/path0/pages/blog/author/[author].vue")
  },
  {
    name: "blog-category-category",
    path: "/blog/category/:category()",
    component: () => import("/vercel/path0/pages/blog/category/[category].vue")
  },
  {
    name: component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyUMeta?.name,
    path: "/reviews",
    component: component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyU
  },
  {
    name: component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyUMeta?.name,
    path: "/india/e-visa",
    component: component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyU
  },
  {
    name: component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyUMeta?.name,
    path: "/vietnam/urgent-visa",
    component: component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyU
  },
  {
    name: component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyUMeta?.name,
    path: "/%D0%B1%D0%BB%D0%BE%D0%B3-%D0%BD%D0%BE%D0%B2%D0%BE%D1%81%D1%82%D0%B8",
    component: component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyU
  },
  {
    name: component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyUMeta?.name,
    path: "/%D0%B2%D0%B8%D0%B7%D0%B0-%D0%B2-%D0%B8%D0%BD%D0%B4%D0%B8%D1%8E-%D0%B4%D0%BE%D1%81%D1%82%D1%83%D0%BF%D0%BD%D0%B0-%D0%B4%D0%BB%D1%8F-%D1%82%D1%83%D1%80%D0%B8%D0%B7%D0%BC%D0%B0-2021",
    component: component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyU
  },
  {
    name: component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyUMeta?.name,
    path: "/usa",
    component: component_45stub0Eom4qaJK3CaUW3iva7oXuFlZX9Cj3pfu2trfe_45HMyU
  }
]